<template>
  <component
    :is="getComponent(item.component)"
    v-bind="componentProps"
    :value="itemValue"
    :data-field="item.key"
    :validator="validator"
    v-tooltip.bottom="item.disabled"
    @input="handleInput"
  >
    <template v-for="(slotItems, slotName) in item.slots" v-slot:[slotName]="slotScope">
      <FieldRenderer
        v-for="(slotItem, index) in slotItems"
        :key="safeKey(slotItem, slotName, index)"
        :item="slotItem"
        :value="value"
        :validator="validator"
        :parent-scope="slotScope"
        @input="handleInput"
      />
    </template>
  </component>
</template>

<script>
import { setByPath } from '@/utils'
import { MediaComponent } from '@kvass/media'
import MediaRecommendation from '@/components/MediaRecommendation'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'
import FileOnDrop from '@/components/vendors/kvass-file/onDrop'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { FileComponent } from '@kvass/file'
import { InputComponent } from 'vue-elder-input'
import { DropdownComponent } from 'vue-elder-dropdown'
import FlatfinderSelect from '@/components/Flatfinder/Resources/Select/Modal'
import SelectModal from '@kvass/custom-fields/src/Fields/SelectModal'
import Html from '@kvass/custom-fields/src/Fields/Html'

export default {
  name: 'FieldRenderer',
  beforeCreate() {
    this.$options.components.FieldRenderer = require('./FieldRenderer.vue').default
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    parentScope: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    componentProps() {
      return {
        ...(this.item.props || {}),
        ...(this.parentScope || {}),
        disabled: Boolean(this.item.disabled),
      }
    },
    itemValue() {
      const explicitValue = this.item.props && this.item.props.value
      if (explicitValue !== undefined) return explicitValue

      return this.get(this.item.key)
    },
  },
  methods: {
    get(key) {
      if (!key) return undefined
      return this.$path ? this.$path(key, this.value) : undefined
    },

    handleInput(ev) {
      if (this.item.key) {
        setByPath(this.item.key, ev, this.value)
      }
      this.$emit('input', ev)
    },

    safeKey(slotItem, slotName, index) {
      return slotItem.key + '-' + slotName + '-' + index
    },

    getComponent(item) {
      const components = {
        MediaComponent,
        FileComponent,
        DropdownComponent,
        InputComponent,
        MediaRecommendation,
        FileOnDrop,
        MediaOnDrop,
        CheckboxComponent,
        FlatfinderSelect,
        SelectModal,
        Html,
      }
      return components[item] || item
    },
  },
}
</script>
